var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"close-button",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}},[(!_vm.isDark)?_c('img',{attrs:{"src":require("assets/icons/close.svg"),"alt":"Close"}}):_vm._e(),_vm._v(" "),(_vm.isDark)?_c('img',{attrs:{"src":require("assets/icons/close-dark.svg"),"alt":"Close"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-353d839b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generics/close-button/close-button.vue
// module id = jJDj
// module chunks = 0